import { render } from "./MigrationView.vue?vue&type=template&id=5de29c1b&scoped=true&ts=true"
import script from "./MigrationView.vue?vue&type=script&lang=ts"
export * from "./MigrationView.vue?vue&type=script&lang=ts"

import "./MigrationView.vue?vue&type=style&index=0&id=5de29c1b&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de29c1b"]])

export default __exports__